import { Link } from "react-router-dom";
import type { ContentItem } from "@/types/content";
import { formatViews, getCategoryById } from "@/utils/content";

interface Props {
  item: ContentItem;
  index?: number;
}

export default function ContentCard({ item, index = 0 }: Props) {
  const category = getCategoryById(item.categoryId);
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block cursor-pointer animate-fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    >
      <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} 国语对白影音资源封面`}
          title={`${item.title} 国语对白高清影音作品`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2.5 left-2.5 rounded-full bg-accent-500 px-2.5 py-0.5 text-[11px] font-medium text-background-50">
          {item.year}
        </span>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/85 to-transparent px-3 pb-3 pt-8">
          <div className="flex items-center justify-between text-[11px] text-background-100">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line" />
              {formatViews(item.views)}
            </span>
            <span className="flex items-center gap-1 text-accent-300">
              <i className="ri-star-fill" />
              {item.rating}
            </span>
          </div>
        </div>
      </div>
      <div className="mt-2.5">
        <h3 className="text-sm md:text-[15px] font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 truncate">
          {category?.name} · {item.region}
        </p>
      </div>
    </Link>
  );
}